import desktopImg from '@/public/images/onboarding/desktop-step-4.jpg'
import classNames from 'classnames'
import { Button } from 'components/common/Button'
import { RadioGroup } from 'components/common/RadioGroup'
import { OnboardingScreen } from 'components/onboarding/OnboardingScreen'
import {
  OnboardingScreenHeader,
  OnboardingScreenTitles,
} from 'components/onboarding/OnboardingScreenHeader'
import { ONBOARDING_INTENT, ONBOARDING_STATUS } from 'constants/onboarding'
import { useOnboarding } from 'contexts/hooks/useOnboarding'
import { useUserProfile } from 'hooks'
import { useUpdateOnboarding } from 'hooks/onboarding/useUpdateOnboarding'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import { useState } from 'react'

export function PlansOnFairart() {
  const { t } = useTranslation('onboarding')
  const { data: userProfile } = useUserProfile()
  const [value, setValue] = useState(userProfile?.onboarding?.intent || '')
  const { close } = useOnboarding()
  const { mutate: update, isLoading } = useUpdateOnboarding()

  function onAction() {
    update(
      { intent: value, status: ONBOARDING_STATUS.COMPLETED },
      {
        onSuccess: close,
      }
    )
  }

  return (
    <OnboardingScreen desktopImg={desktopImg}>
      <OnboardingScreenHeader step={3}>
        <OnboardingScreenTitles
          title={t('plans_on_fairart.title')}
          className='hidden sm:block'
        />
      </OnboardingScreenHeader>

      <div className='py-6 px-8 pb-10 sm:pb-6 h-full flex flex-col justify-between bg-warm-50'>
        <div
          className={classNames(
            'flex flex-col flex-1 justify-center transition-opacity duration-150',
            isLoading && 'opacity-50'
          )}
        >
          <OnboardingScreenTitles
            title={t('plans_on_fairart.title')}
            className='sm:hidden mb-8'
          />

          <RadioGroup
            value={value}
            onValueChange={setValue}
            items={[
              {
                label: (
                  <Trans
                    i18nKey='onboarding:plans_on_fairart.looking_to_buy'
                    components={{ b: <b /> }}
                  />
                ),
                value: ONBOARDING_INTENT.BUY,
              },
              {
                label: (
                  <Trans
                    i18nKey='onboarding:plans_on_fairart.looking_to_sell'
                    components={{ b: <b /> }}
                  />
                ),
                value: ONBOARDING_INTENT.SELL,
              },
              {
                label: (
                  <Trans
                    i18nKey='onboarding:plans_on_fairart.looking_for_both'
                    components={{ b: <b /> }}
                  />
                ),
                value: ONBOARDING_INTENT.BUY_SELL,
              },
            ]}
          />
        </div>

        <div>
          <div className='sm:hidden w-full'>
            <Button
              style='solid-primary'
              pill
              size='lg'
              className='w-full'
              onClick={onAction}
              disabled={!value || isLoading}
              isLoading={isLoading}
            >
              {t('plans_on_fairart.action')}
            </Button>
          </div>
          <div className='hidden sm:block w-full'>
            <Button
              style='solid-primary'
              pill
              size='md'
              className='w-full'
              onClick={onAction}
              disabled={!value || isLoading}
              isLoading={isLoading}
            >
              {t('plans_on_fairart.action')}
            </Button>
          </div>
        </div>
      </div>
    </OnboardingScreen>
  )
}
